import { Container, Row, Col } from "reactstrap";
import "./index.scss";

const CalenderSection = () => {
  return (
    <section className="calender-section">
      <Container data-aos="fade-up">
        <Row>
          <Col>
            <h2 className="title">CALENDER</h2>
            <div className="calender">
              <div className="calender-item">
                <div className="item-title">
                  <h3>
                    ENGINEERING <br /> CAMP
                  </h3>
                </div>
                <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                  9-10-11 <br />
                  FEBRUARY 2023
                </div>
              </div>
              <div className="calender-item">
                <div className="item-title">
                  <h3>
                    FMCG <br />
                    CAMP
                  </h3>
                </div>
                <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                  16-17-18 <br /> FEBRUARY 2023
                </div>
              </div>
              <div className="calender-item">
                <div className="item-title">
                  <h3>
                    FINANCE & AUDIT <br /> CAMP
                  </h3>
                </div>
                <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                  24-25 <br />
                  FEBRUARY 2023
                </div>
              </div>
              <div className="calender-item">
                <div className="item-title">
                  <h3>TECHNOLOGY CAMP</h3>
                </div>
                <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                  3<br />
                  MARCH 2023
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="background"></div>
    </section>
  );
};

export default CalenderSection;
